<!-- EDS Banner and filters -->
<div edsSpacing="xl" *ngIf="!isError">
  <ft-document-filters
    [page]="page"
    [component]="component"
    [isLoaded]="dataLoaded"
    [numberOfFliterData]="numberOfFliterData"
    [totalNumberOfData]="totalNumberOfData"
    (downloadExcel)="downloadExcel()"
  ></ft-document-filters>
</div>
<div *ngIf="isError">
  <eds-breadcrumbs
    [items]="showBreadcrumb ? breadcrumbItems : null"
    theme="basic"
    edsPadding
    edsPaddingLeft="sm"
  >
  </eds-breadcrumbs>
  <div edsGrid>
    <div class="container">
      <div edsRow>
        <div edsCol>
          <div edsPadding edsPaddingAll="lg">
            <div edsSpacing="lg">
              <eds-image
                imgSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
                imgFallbackSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
              >
              </eds-image>
            </div>
            <eds-title edsSpacing="sm" size="h3" theme="dark">
              {{ "literature.lit-error-message" | translate }}
            </eds-title>
            <ul
              class="list--unordered"
              edsList
              innerHTML="{{
                'literature.lit-listing-no-data-result-message-list' | translate
              }}"
            ></ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  edsGrid
  edsSpacing="md"
  *ngIf="
    numberOfFliterData !== 0 &&
    !isInternational &&
    showClientToggle &&
    !isCustom
  "
>
  <div edsRow>
    <div edsCol>
      <div edsFlexbox>
        <div class="text-space">
          <eds-title size="small-light">
            {{ "literature.client-use-only" | translate }}
            ({{ clientUseYesCount }})
          </eds-title>
        </div>
        <eds-toggle
          [toggleButtons]="clientUseToggle"
          (toggleActive)="filterOnClientUse($event)"
        ></eds-toggle>
      </div>
    </div>
  </div>
</div>

<!-- <div *ngIf="rowData?.length === 0 && !dataLoaded && !isError" edsGrid>

  <div edsRow edsSpacing="md" alignItems="center">

    <ngx-skeleton-loader
      edsCol
      [theme]="{
        'background-color': '#e8e8e8',
        'border-radius': '0',
        height: 'var(--space-xxl)'
      }"
    ></ngx-skeleton-loader>

    <ngx-skeleton-loader
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 2 }"
      [theme]="{
        'background-color': '#e8e8e8',
        'border-radius': '0',
        height: 'var(--space-xxl)'
      }"
    ></ngx-skeleton-loader>
  </div>

  <div edsRow>
    <ngx-skeleton-loader
      edsCol
      [count]="20"
      animation="pulse"
      [theme]="{
        'background-color': '#e8e8e8',
        'border-radius': '0',
        height: 'var(--space-xxl)'
      }"
    ></ngx-skeleton-loader>
  </div>
</div> -->
<!-- / end of skeleton loader -->
<ng-container *ngIf="isCustom">
  <eds-proximal placement="RegulatoryFundDocumentTop"></eds-proximal>
</ng-container>
<div id="literatureScrollPosition"></div>
<ng-container *ngIf="numberOfFliterData === 0 && dataLoaded">
  <div edsGrid>
    <div class="container">
      <div edsRow>
        <div edsCol>
          <div edsPadding edsPaddingAll="lg">
            <div edsSpacing="lg">
              <eds-image
                imgSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
                imgFallbackSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
              >
              </eds-image>
            </div>
            <eds-title edsSpacing="sm" size="h3" theme="dark">
              {{
                "literature.lit-listing-no-search-result-message-start"
                  | translate
              }}
              {{ searchKey }}
              {{
                "literature.lit-listing-no-search-result-message-end"
                  | translate
              }}
            </eds-title>
            <eds-title edsSpacing="sm" size="h6" theme="dark">
              {{
                "literature.lit-listing-no-search-result-message-suggestion"
                  | translate
              }}
            </eds-title>
            <ul
              class="list--unordered"
              edsList
              innerHTML="{{
                'literature.lit-listing-no-search-result-message-list'
                  | translate
              }}"
            ></ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="numberOfFliterData !== 0 && !isHandheld">
  <div edsGrid>
    <div *ngIf="!isCustom" edsRow>
      <eds-proximal edsCol placement="LiteratureListingTop"></eds-proximal>
    </div>
    <div *ngIf="isRequeryResult" edsRow>
      <eds-title edsCol edsSpacing="sm" size="h6" theme="dark">
        {{ "literature.lit-results-returned-with-no-filters-set" | translate }}
      </eds-title>
    </div>
    <div edsRow *ngIf="!isCustom">
      <div edsCol edsSpacing="md">
        <ag-grid-angular
          stickyHeader
          #literatureDocumentGrid
          style="width: 100%; height: 100%"
          class="ag-theme-frk"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [frameworkComponents]="frameworkComponents"
          [rowSelection]="'multiple'"
          [paginationPageSize]="paginationPageSize"
          [suppressPaginationPanel]="true"
          [suppressHorizontalScroll]="true"
          [suppressRowClickSelection]="true"
          [isExternalFilterPresent]="isExternalFilterPresent"
          [doesExternalFilterPass]="doesExternalFilterPass"
          [context]="gridContext"
          [pagination]="true"
          rowHeight="124"
          domLayout="autoHeight"
          [suppressRowHoverHighlight]="true"
          [suppressCellSelection]="false"
          [ensureDomOrder]="true"
          (gridReady)="onGridReady($event)"
          [enableCellTextSelection]="true"
        >
        </ag-grid-angular>
      </div>
    </div>
  </div>
</ng-container>
<div edsRow *ngIf="customRowData?.length > 0 && !isHandheld && isCustom">
  <div
    edsCol
    edsPadding
    edsPaddingLeft="xxl"
    edsPaddingRight="xxl"
    edsSpacing="md"
  >
    <ag-grid-angular
      stickyHeader
      #literatureDocumentGrid
      style="width: 100%; height: 100%"
      class="ag-theme-frk"
      [rowData]="customRowData"
      [columnDefs]="columnDefs"
      [frameworkComponents]="frameworkComponents"
      [rowSelection]="'multiple'"
      [paginationPageSize]="paginationPageSize"
      [suppressPaginationPanel]="true"
      [suppressHorizontalScroll]="true"
      [isExternalFilterPresent]="isExternalFilterPresent"
      [doesExternalFilterPass]="doesExternalFilterPass"
      [context]="gridContext"
      [suppressRowClickSelection]="true"
      [pagination]="false"
      rowHeight="124"
      domLayout="autoHeight"
      headerHeight="60"
      [suppressRowHoverHighlight]="true"
      [suppressCellSelection]="false"
      [ensureDomOrder]="true"
      [enableCellTextSelection]="true"
    >
    </ag-grid-angular>
  </div>
</div>
<!-- Mobile view -->
<ng-container *ngIf="numberOfFliterData !== 0 && isHandheld">
  <!-- Showing X of Y -->
  <div edsGrid>
    <div edsRow *ngIf="!isCustom">
      <div edsCol edsSpacing="md" [columnNumbers]="{ s: 2, m: 4, l: 2 }">
        <eds-dropdown
          *ngIf="isHandheld"
          ariaLabel="Dropdown"
          [id]="'id1'"
          [name]="'name1'"
          [items]="sortByItems"
          [label]="sortByDropDownLabel"
          [preselectedValue]="sortByItems[0]"
          (dropdownChange)="onSorting(rowData, $event)"
        ></eds-dropdown>
      </div>
    </div>
    <div edsRow *ngIf="!isCustom">
      <eds-proximal edsCol placement="LiteratureListingTop"></eds-proximal>
    </div>

    <ft-literature-document-card-container
      [rowData]="currentPage"
      [columnDefs]="columnDefs"
      [isCustom]="isCustom"
      (selectionEmitter)="onSelectionChanged($event, href)"
      edsRow
    ></ft-literature-document-card-container>
  </div>
</ng-container>
<div edsGrid *ngIf="!isCustom">
  <div edsRow>
    <div
      edsCol
      [columnNumbers]="{ s: 4, m: 6, l: 10 }"
      [edsSpacing]="(isMobile$ | async) === true ? 'md' : 'none'"
      edsFlexbox
      [justifyContent]="(isMobile$ | async) === true ? 'center' : 'left'"
    >
      <eds-pagination
        *ngIf="numberOfPages > 0"
        [pages]="numberOfPages"
        [activePage]="activePage"
        (pageChanged)="onPageChanged($event)"
        prevPageText="{{ 'literature.previous' | translate }}"
        nextPageText="{{ 'literature.next' | translate }}"
      >
      </eds-pagination>
    </div>
    <div
      edsCol
      [columnNumbers]="{ s: 4, m: 2, l: 2 }"
      edsFlexbox
      justifyContent="right"
    >
      <div edsCol [columnNumbers]="{ s: 2, m: 8, l: 12 }">
        <eds-dropdown
          ariaLabel="Dropdown"
          [id]="'id'"
          *ngIf="numberOfFliterData !== 0"
          [name]="'name'"
          [items]="rowNoItems"
          [label]="rowsNoDropDownLabel"
          [preselectedValue]="pageSize"
          (dropdownChange)="onChange($event)"
        >
        </eds-dropdown>
      </div>
    </div>
    <!-- / Dropdown -->
  </div>
</div>
<ng-container *ngIf="isCustom">
  <eds-proximal placement="RegulatoryFundDocumentBottom"></eds-proximal>
</ng-container>
<div edsGrid>
  <div edsRow>
    <ft-literature-dialog
      [dialogId]="ModalIdValue"
      [modalIdEnum]="ModalId['Sticky_Modal']"
      [multiSelectDialogData]="multiSelectDialogData"
      [confirmSelectionCount]="confirmSelectionNodes?.length"
      (dialog)="closeDialog($event)"
      (deleteDoc)="deselectedDownloadDocs($event)"
      (downloadStart)="startDownload()"
      (emailStart)="startEmail()"
      (modalClose)="closeModal(ModalId['Sticky_Modal'])"
      (backEmail)="emailBack()"
      (continueEmail)="emailContinue($event)"
      (deleteCartDoc)="updateStorage($event)"
      [gridData]="dialogData"
      (selectAll)="selectAllPopupAction($event)"
      (modalClosedInternally)="modalClosedInternally($event)"
      (emptyCart)="emptyCart($event)"
    ></ft-literature-dialog>
  </div>
</div>
<eds-sticky-footer
  [itemCount]="rowCountValue"
  [isHide]="rowCount === 0"
  variation="2"
  [primaryAction]="emailStickyButton"
  [secondaryAction]="downloadStickyButton"
  [tertiaryAction]="addToCartStickyButton"
  (btnSubscribePrimary)="operationToPerform('email')"
  (btnSubscribeSecond)="operationToPerform('download')"
  (btnSubscribeThird)="operationToPerform('addToCart')"
  [stickyFooterName]="'document_listing_sticky_footer'"
></eds-sticky-footer>
